/*
 * LocationIntro — Section 2/10 for /garage-door-repair-south-sydney/
 * MASTER TEMPLATE — duplicate for other locations, change only the LOC block.
 * Paste this ENTIRE file into src/pages/GarageDoorRepairSouthSydney/sections/LocationIntro.tsx
 */

// ╔══════════════════════════════════════════════════════════════════╗
// ║  LOC CONFIG — change ONLY this block when duplicating          ║
// ╚══════════════════════════════════════════════════════════════════╝
const LOC = {
  name: "South Sydney",
  dropCap: "S",
  paragraph1: "outh Sydney is right next door — and that means the fastest response times in our network. One number: <strong>0485 000 933</strong>. We\'ve been fixing doors across Mascot, Rockdale, Kogarah and Hurstville since 2009.",
  paragraph2: "Our Bass Hill base puts us 15–20 minutes from most South Sydney suburbs. Whether it\'s a unit block in Mascot, a family home in Hurstville, or a waterfront property in Sans Souci — we carry the parts and get it done first visit. No second trips.",
  ctaLabel: "Book a South Sydney Technician",
  facts: [{
    value: "2009",
    label: "Serving Sydney since"
  }, {
    value: "15–20 min",
    label: "From our base to you"
  }, {
    value: "1,100+",
    label: "Local jobs completed"
  }, {
    value: "Same day",
    label: "Response across all suburbs"
  }]
};
// ╚══════════════════════════════════════════════════════════════════╝

const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const CREAM2 = "#F0EBE0";
const INK = "#1A1F2E";
const INK2 = "#5A6478";
const NAVY = "#081438";
export default function LocationIntro() {
  return <section id="location-intro" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden"
  }}>

      {/* Wave top — DUPLICATE from LocationHero bottom */}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,60 C360,0 1080,0 1440,60 L1440,0 L0,0 Z" fill={NAVY} />
        </svg>
      </div>

      {/* Paper grain */}
      <svg aria-hidden="true" style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.04,
      pointerEvents: "none",
      zIndex: 1
    }}>
        <filter id="li-grain"><feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="4" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#li-grain)" />
      </svg>

      {/* Corner ornaments */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: "40px",
      left: "40px",
      width: "64px",
      height: "64px",
      borderTop: `2px solid ${GOLD}50`,
      borderLeft: `2px solid ${GOLD}50`,
      zIndex: 1
    }} />
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: "40px",
      right: "40px",
      width: "64px",
      height: "64px",
      borderBottom: `2px solid ${GOLD}50`,
      borderRight: `2px solid ${GOLD}50`,
      zIndex: 1
    }} />

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "clamp(56px,7vw,88px) clamp(20px,5vw,48px)"
    }}>

        <div style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "48px"
      }} className="lg:!grid-cols-[3fr_2fr]">

          {/* Editorial copy */}
          <div>
            <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "28px"
          }}>
              <div style={{
              width: "32px",
              height: "2px",
              background: GOLD
            }} />
              <span style={{
              fontFamily: "Manrope,sans-serif",
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: GOLD_DARK
            }}>
                Your Local Team
              </span>
            </div>

            {/* Drop-cap paragraph */}
            <div style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "clamp(15px,1.6vw,17px)",
            color: INK2,
            lineHeight: 1.8,
            marginBottom: "24px"
          }}>
              <span style={{
              float: "left",
              fontFamily: "Plus Jakarta Sans,sans-serif",
              fontWeight: 800,
              fontSize: "clamp(56px,7vw,80px)",
              lineHeight: 0.85,
              color: GOLD_DARK,
              marginRight: "12px",
              marginTop: "8px"
            }}>{LOC.dropCap}</span>
              <span dangerouslySetInnerHTML={{
              __html: LOC.paragraph1
            }} />
            </div>

            <p style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "clamp(14px,1.5vw,16px)",
            color: INK2,
            lineHeight: 1.8,
            marginBottom: "32px"
          }}>
              {LOC.paragraph2}
            </p>

            {/* Trust badges */}
            <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px"
          }}>
              {["1-Year Labour Warranty", "Same-day bookings", "No hidden fees", "5.0★ rated locally"].map(t => <div key={t} style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              background: CREAM2,
              border: `1px solid ${GOLD}30`,
              borderRadius: "999px",
              padding: "7px 16px"
            }}>
                  <span style={{
                color: GOLD_DARK,
                fontSize: "13px"
              }}>✓</span>
                  <span style={{
                fontFamily: "Manrope,sans-serif",
                fontSize: "13px",
                color: INK,
                fontWeight: 600
              }}>{t}</span>
                </div>)}
            </div>
          </div>

          {/* By-the-numbers card */}
          <div style={{
          background: "#FFFFFF",
          border: `1px solid ${GOLD}25`,
          borderRadius: "16px",
          padding: "clamp(28px,3vw,40px)",
          boxShadow: "0 4px 32px rgba(0,0,0,0.06)",
          alignSelf: "start"
        }}>
            <p style={{
            fontFamily: "Plus Jakarta Sans,sans-serif",
            fontWeight: 800,
            fontSize: "14px",
            color: INK,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            marginBottom: "28px"
          }}>
              By the Numbers
            </p>
            <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          }}>
              {LOC.facts.map(f => <div key={f.label} style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
              paddingBottom: "16px",
              borderBottom: `1px solid ${CREAM2}`
            }}>
                  <span style={{
                fontFamily: "Manrope,sans-serif",
                fontSize: "13px",
                color: INK2,
                fontWeight: 500
              }}>{f.label}</span>
                  <span style={{
                fontFamily: "Plus Jakarta Sans,sans-serif",
                fontWeight: 800,
                fontSize: "22px",
                color: GOLD_DARK
              }}>{f.value}</span>
                </div>)}
            </div>
            <a href="tel:0485000933" style={{
            display: "block",
            marginTop: "24px",
            textAlign: "center",
            background: NAVY,
            color: "#FFF",
            padding: "13px",
            borderRadius: "8px",
            fontFamily: "Manrope,sans-serif",
            fontWeight: 700,
            fontSize: "14px",
            textDecoration: "none"
          }}>
              {LOC.ctaLabel}
            </a>
          </div>
        </div>
      </div>

      {/* Wave bottom — DUPLICATE in LocationServices top */}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,0 C360,60 1080,60 1440,0 L1440,60 L0,60 Z" fill={NAVY} />
        </svg>
      </div>
    </section>;
}